
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/abc-podatkow/[id]",
      function () {
        return require("private-next-pages/abc-podatkow/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/abc-podatkow/[id]"])
      });
    }
  